import {
	FETCH_SHIPPERS_REQUEST,
	FETCH_SHIPPERS_SUCCESS,
	FETCH_SHIPPERS_FAIL,
	EXPORT_SHIPPERS_REQUEST,
	EXPORT_SHIPPERS_SUCCESS,
	EXPORT_SHIPPERS_FAIL,
} from "../constants/shipper";

function fetchShippersReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}
	switch (action.type) {
		case FETCH_SHIPPERS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SHIPPERS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				shippers: action.payload,
			};
		case FETCH_SHIPPERS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function exportShippersReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}
	switch (action.type) {
		case EXPORT_SHIPPERS_REQUEST:
			return { loading: true, status: "IDLE" };
		case EXPORT_SHIPPERS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				file: action.payload,
			};
		case EXPORT_SHIPPERS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export { fetchShippersReducer, exportShippersReducer };
